module.exports = __webpack_public_path__ + "static/media/check-circle-success.7d4eb20e.svg";